import tuGiaImage1 from "../assets/img/hatvui4.png";
import tuGiaImage2 from "../assets/img/hatvui6.png";

const tuGiaData = [
  {
    id: 1,
    title: "Bài Giã từ",
    videoUrl: "https://res.cloudinary.com/dmiuw4ekf/video/upload/v1765267106/giatu_b4gcbc.mov",
    content: `**(Nghệ nhân đờn cò dạo đầu, trống phách gõ theo, kết thúc phần dạo đầu, cái kể vào nhịp)**  
**Cái kể**: Tiệc bày duyên đã mãn rồi,  
**Con xô**: Trình trong gia chủ ở đây thái bình.  
**Cái kể**: Năm nay tòng - bá hiệp trùng,  
**Con xô**: Phụ tùng phu xướng cửa nhà bình yên.  
**Cái kể**: Tam tai khống khứ, tống ra khỏi làng.  
**Con xô**: Tống cho ra khỏi thôn trang,  
**Cái kể**: Mênh mông giữa biển, lao đao giữa vời.  
**Con xô**: Dậy thời sang cả ngôi cao.  
Cái kể - Con xô: Kính dâng bốn chữ phụng mao trinh tường  
Cái kể - Con xô: Kính dâng bốn chữ phụng mao trinh tường  

**Mốc thời gian**: Được ghi nhận trong các nghi lễ Sắc Bùa Phú Lễ từ thời xa xưa, phổ biến trong các cuộc khảo sát văn hóa dân gian.`,
    image: tuGiaImage1,
    year: "Truyền thống",
    type: "Từ giã",
    icon: "🎶",
    description:
      "Bài hát giã từ gia chủ, thể hiện sự kết thúc nghi lễ và cầu chúc bình an, xua đuổi tai ương.",
    modernDevelopment:
      "Vẫn được trình diễn trong các nghi lễ từ giã tại Phú Lễ, giữ nguyên nét truyền thống.",
  },
  {
    id: 2,
    title: "Bài Đi ra",
    videoUrl:
      "https://res.cloudinary.com/dmiuw4ekf/video/upload/v1765264985/baidira_h4t08z.mov",
    content: `**(Nghệ nhân đờn cò dạo đầu, trống phách gõ theo, kết thúc phần dạo đầu, cái kể vào nhịp)**  
**Cái kể**: Ăn trầu đã đặng  
**Cái kể**: Hút thuốc đã rồi  
**Cái kể**: Trình cô bác ngồi  
**Cái kể**: Chúng tôi đi ra  
Cái kể - Con xô: Đi ra! Đi ra!  
Cái kể - Con xô: Đủ chúng bạn ta  
**Cái kể**: Lớn thời đi trước  
**Con xô**: Nhỏ lại đi sau  
**Cái kể**: Đến chỗ sang giàu  
**Con xô**: Chơi xuân năm mới  
**Cái kể**: Chúc thanh chúc thọ  
**Con xô**: Làm tuổi ông bà  
Cái kể - Con xô: Năm mới giàu sang  
Cái kể - Con xô: Gia quan tấn lộc  

**Mốc thời gian**: Được ghi nhận trong các nghi lễ Sắc Bùa Phú Lễ từ thời xa xưa, phổ biến trong các cuộc khảo sát văn hóa dân gian.`,
    image: tuGiaImage2,
    year: "Truyền thống",
    type: "Từ giã",
    icon: "🎶",
    description:
      "Bài hát đánh dấu sự rời đi của đoàn Sắc Bùa, cầu chúc gia chủ giàu sang và trường thọ.",
    modernDevelopment:
      "Tiếp tục được biểu diễn trong các nghi lễ từ giã tại Phú Lễ, mang đậm tính truyền thống.",
  },
];

export default tuGiaData;
